export default __webpack_public_path__ + "static/media/institution-empty.fe36a996.jpg";